import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-20 bg-black text-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <h1 className="text-4xl md:text-5xl font-black mb-8 uppercase tracking-tight text-center">
          HOUSE OF PM SPORTS SHOP FOR PERFORMANCE, STYLE & INNOVATION – SINCE 2024
        </h1>
        
        <div className="space-y-6 text-base md:text-lg leading-relaxed">
          <p>
            Sport keeps us fit. Keeps you mindful. Brings us together. Through sport, we have the power to change lives—through stories of inspiring athletes, innovative technology, and by helping you get up and move.
          </p>
          
          <p>
            Find high-performance activewear and sportswear built with the latest technology to help you push your limits. Whether you're a runner, a basketball player, a footballer, or someone who just loves to stay active, our sports shop is your home. We're here to help you train harder, run faster, and go further, with products that keep up with your movement and support your goals.
          </p>
          
          <p>
            Explore our online store for the latest collections, where innovation meets style. From the yoga teacher spreading the joy of movement to the weekend hiker escaping the city, we support everyone striving to be their best. The sports shop at House of PM offers performance gear for all levels—whether you're an elite athlete, a fitness enthusiast, or just starting your journey. Our online store ensures that wherever you are, you can access the latest gear designed for movement.
          </p>
          
          <p>
            The House of PM sports store is more than just a place to shop—it's a space for creators to elevate their game and redefine what's possible. Every item in our sports shop is crafted with performance, durability, and attention to detail in mind, helping you move with confidence. At House of PM, we partner with the best in the industry to co-create, ensuring every piece of apparel supports movement, self-expression, and an active lifestyle. Wherever your sport takes you, our sports shop has you covered—helping you take every step toward greatness.
          </p>
        </div>
        
        <div className="flex justify-center mt-12">
          <svg className="w-16 h-16" viewBox="0 0 50 50" fill="white">
            <path d="M25 5L45 45H5L25 5Z" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
